import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteSupportSlice = createSlice({
    name: "deleteSupport",
    initialState,
    reducers: {
        deleteSupportRequest(state) {
            state.loading = true;
        },
        deleteSupportRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteSupportRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteSupportStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteSupportRequest,
    deleteSupportRequestSuccess,
    deleteSupportRequestError,
    deleteSupportStateReset,
} = DeleteSupportSlice.actions;

export default DeleteSupportSlice.reducer;
